import { Wrench, Cog, Flame, Droplets, Thermometer, Zap, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/config";

const ICONS = { Wrench, Cog, Flame, Droplets, Thermometer, Zap };

export default function Services() {
  return (
    <section id="services" className="py-20 lg:py-32 bg-white border-y border-zinc-200" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 mb-12 lg:mb-16">
          <div className="lg:col-span-5">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#1D4ED8] mb-4" data-testid="services-overline">
              / Hizmetlerimiz
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-zinc-950 leading-[1.05]" data-testid="services-title">
              Tesisata dair <br /> <span className="text-[#FF4500]">her şey.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-base lg:text-lg text-zinc-600 leading-relaxed" data-testid="services-description">
              Kombi arızasından doğalgaz tesisatına, radyatör temizliğinden elektrikli
              kombi montajına kadar evinizin ve iş yerinizin tüm ısıtma &amp; tesisat
              ihtiyaçları için tek adres.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 border border-zinc-200">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Wrench;
            return (
              <div
                key={s.id}
                className="group relative bg-white border-zinc-200 p-6 lg:p-8 transition-colors duration-300 hover:bg-zinc-50 [&:not(:last-child)]:border-b sm:[&:not(:nth-last-child(-n+2))]:border-b sm:[&:nth-child(odd)]:border-r lg:[&:nth-child(3n+1)]:border-r lg:[&:nth-child(3n+2)]:border-r lg:[&:nth-last-child(-n+3)]:border-b-0 sm:[&:nth-child(odd)]:border-r-0 lg:[&:nth-child(3n+2)]:border-r"
                data-testid={`service-card-${s.id}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 bg-[#FF4500]/10 border border-[#FF4500]/20 flex items-center justify-center rounded-sm group-hover:bg-[#FF4500] transition-colors">
                    <Icon className="w-6 h-6 text-[#FF4500] group-hover:text-white transition-colors" />
                  </div>
                  <span className="text-xs font-mono text-zinc-400">0{i + 1}</span>
                </div>
                <h3 className="text-xl font-extrabold tracking-tight text-zinc-950 mb-2" data-testid={`service-title-${s.id}`}>
                  {s.title}
                </h3>
                <p className="text-sm text-zinc-600 leading-relaxed mb-6">
                  {s.desc}
                </p>
                <a
                  href="#appointment"
                  className="inline-flex items-center gap-1 text-sm font-bold text-zinc-950 border-b border-zinc-950 pb-0.5 group-hover:text-[#FF4500] group-hover:border-[#FF4500]"
                  data-testid={`service-cta-${s.id}`}
                >
                  Randevu Al <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
